/* eslint-disable unicorn/prefer-string-slice */
import analytics from 'lib/analytics/segment/load'
import {
	getAccessToken,
	getServiceHostAndEndpointPath
} from 'lib/interceptor/axios.interceptor'

export const getReportUrl = ({
	reportPath,
	eventPlanId,
	templates,
	params
}: {
	reportPath: string | null
	eventPlanId: string | null
	templates: string | null
	params: Record<string, string | null>
}) => {
	const parametersString = Object.keys(params)
		.filter(k => params[k])
		.map(k => `${k}=${params[k]}`)
		.join('&')
	const { host, endpointPath } = getServiceHostAndEndpointPath(
		`/rpt/api/reports/${reportPath}/${eventPlanId}?templates=${templates}&${parametersString}`
	)
	return `${host}${endpointPath}`
}

export const downloadReport = async ({
	openWindow,
	reportPath,
	eventPlanId,
	templates,
	params,
	impersonate
}: {
	openWindow: boolean
	reportPath: string | null
	eventPlanId: string | null
	templates: string | null
	params: Record<string, string | null>
	impersonate?: string | null
}) => {
	analytics.track('Report Downloaded', {
		reportPath,
		templates,
		params
	})
	getAccessToken()
		.then(accessToken => {
			const url = getReportUrl({ reportPath, eventPlanId, templates, params })
			let impersonateQs = ''
			if (impersonate) {
				impersonateQs = `&hopskip-userprofile-id=${encodeURIComponent(impersonate)}`
			}
			if (openWindow) {
				globalThis.open(`${url}&bearer=${accessToken}${impersonateQs}`)
			} else {
				globalThis.location.href = `${url}&bearer=${accessToken}${impersonateQs}`
			}
		})
		.catch((error: unknown) => console.error(error))
}

// Maps utilities

export const geocodeByAddress = async (
	address: string
): Promise<google.maps.GeocoderResult[] | null> => {
	const geocoder = new globalThis.google.maps.Geocoder()
	const { OK } = globalThis.google.maps.GeocoderStatus

	const results: google.maps.GeocoderResult[] | null = await new Promise(
		(resolve, reject) => {
			void geocoder.geocode(
				{ address },
				(response, status: google.maps.GeocoderStatus) => {
					if (status === OK) {
						resolve(response)
					} else {
						reject(new Error(`Geocoder failed with status: ${status}`))
					}
				}
			)
		}
	)
	return results
}

// export const getLatLng = async result =>
// 	new Promise((resolve, reject) => {
// 		try {
// 			const latLng = {
// 				lat: result.geometry.location.lat(),
// 				lng: result.geometry.location.lng()
// 			}
// 			resolve(latLng)
// 		} catch (error) {
// 			reject(error)
// 		}
// 	})

// export const geocodeByPlaceId = async (placeId: string) => {
// 	const geocoder = new globalThis.google.maps.Geocoder()
// 	const { OK } = globalThis.google.maps.GeocoderStatus

// 	return new Promise((resolve, reject) => {
// 		geocoder.geocode({ placeId }, (results, status) => {
// 			if (status !== OK) {
// 				reject(status)
// 			}
// 			resolve(results)
// 		})
// 	})
// }

export const getCookie = (cname: string) => {
	const name = `${cname}=`
	const decodedCookie = decodeURIComponent(document.cookie)
	const ca = decodedCookie.split(';')
	for (let c of ca) {
		while (c.startsWith(' ')) {
			c = c.slice(1)
		}
		if (c.startsWith(name)) {
			return c.substring(name.length, c.length)
		}
	}
	return ''
}
